export default __webpack_public_path__ + "static/media/Project-3-SingleProject-MainImg.2fd9ab80.png";